import { DueData, TerritoryViolation } from '@/config/types';
import showError from '@/handler/error';
import { apiConfig, refreshTmxToken } from '../api-config';

export const getViolations = async (dueData: DueData) => apiConfig
  .post('api/territory/violations', dueData, { headers: { authorization: sessionStorage.getItem('chave')?.toString() } })
  .then((response) => response.data as TerritoryViolation[])
  .catch(async (error) => {
    if (error.response.status === 401) {
      await refreshTmxToken();
      return getViolations(dueData);
    }
    showError(error);
    return [];
  });
